import * as React from 'react'
import Image from 'components/Image';

import octopus from 'images/illustrations/octopus.svg';
import mermaid from 'images/illustrations/mermaid.svg';

const illustrations = {
	octopus,
	mermaid,
};

export default function Illustration({ illustration, ...props }) {
	if (illustrations[illustration] === undefined)return (
		<div>{illustration} is not found.</div>
	)
	const args = {
		src: illustrations[illustration],
		...props,
	};
	return <Image {...args} />
}